import _, {get} from 'lodash';
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ModalForm from '../../common/components/c_ModalForm';
import TextField from '../../common/components/c_TextField';
import {validate} from '../../modelValidator'; // returns an array of validation errors (empty array if none)
import {getSchema as getUserSchema} from '../../models/user';
import cx from 'classnames';
import { resetPasswordRequest } from '../../redux/api/auth';

const loginSchema = _.pick(getUserSchema(), 'email'); // this page only uses email and password

@connect(state => ({
  labels: get(state.labels, 'Common', {}),
}))
export default class ResetPassword extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    labels: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);

    this.state = {
      dirty: false,
      opaque: false,
      disabled: true,
      error: false,
      step: this.FORM
    };
  }

  setDirty = () => {
    this.setState({...this.state, dirty: true});
  }

  FORM = 0
  SUBMIT = 1
  COMPLETE = 2

  handleChange = (event) => {
    const newState = _.merge({}, this.state);
    newState.error = false;
    newState.email = event.target.value;
    newState.disabled = !!validate({email:newState.email}, loginSchema).length;
    this.setState(newState);
  }

  handleClose = () => {
    window.location = this.props.labels.website;
  }

  handleSubmit = () => {
    const newState = _.merge({}, this.state);
    newState.step = this.SUBMIT;
    newState.disabled = true;
    this.setState(newState);
    resetPasswordRequest(this.state.email)
    .then(() => this.setState({...newState, step: this.COMPLETE}))
    .catch(() => {
      newState.disabled = false;
      newState.error = true;
      newState.step = this.FORM;
      this.setState(newState);
    });
  }
  
  renderForm() {
    return (
      <div className='password-entry'>
        <span>
          We’ll send you an email with a reset link.
        </span>
        <TextField className='full-width'
                  floatingLabelText='Email'
                  data-id='Email'
                  onChange={this.handleChange}
                  onFocus={this.setDirty}/>
        <div className={cx('error-message', {opaque: this.state.opaque})}>
          Your email is incorrect
        </div>
        <div className={cx('error-message', {opaque: this.state.error})}>
          Ooops, something went wrong.
        </div>
      </div>
    );
  }

  renderSubmit() {
    return (
      <div className='password-message'>
        <hr className='message-divider'/>
        <div className='message-body'>
          Please wait
        </div>
      </div>
    );
  }

  renderComplete() {
    return (
      <div className='password-message'>
        <hr className='message-divider'/>
        <div className='welcome-body message-body'>
          Please follow the link in the email to reset your password.
        </div>
        <div className='welcome-body message-body'>
          Please remember to check your Spam and/or Junk Mail folders in case you don't see the message in your Inbox.
        </div>
        <div className='welcome-body message-body'>
          Should you need assistance with resetting your password or logging in, please contact our<br></br>IT Team by calling 646-807-4372 and press #2.<br></br>Our IT Team will be happy to assist you.
        </div>
      </div>
    );
  }

  render() {
    let prompt = '';
    let promptStyle = 'reset-form';

    switch(this.state.step) {
      case this.SUBMIT:
        prompt = 'Sending Email';
        break;
      case this.COMPLETE:
        prompt = 'Email Sent';
        promptStyle = 'reset-form-success';
        break;
      default:
        prompt = 'Change Password';
    }

    return (
      <div>
        <ModalForm className={promptStyle}
                   prompt={prompt}
                   onClose={this.handleClose}
                   button={{
                      label: 'Reset',
                      onClick: this.handleSubmit,
                      disabled: this.state.disabled
                  }}>
          {
            (this.state.step === this.FORM)
            &&
            this.renderForm()
              ||
            (this.state.step === this.SUBMIT)
            &&
            this.renderSubmit()
              ||
            (this.state.step === this.COMPLETE)
            &&
            this.renderComplete()
          }
          {
            this.props.children
          }
        </ModalForm>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/public/ResetPassword.js